var _mask, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashGold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 74,
    viewBox: "0 0 132 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 132,
    height: 74
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0493164,
    width: 131.109,
    height: 74,
    rx: 9,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0493164,
    width: 131.109,
    height: 74,
    rx: 9,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.667 24.0896C72.8722 24.0896 68.3389 23.2553 64.9022 21.7402C63.8736 21.2867 62.9693 20.7815 62.1942 20.2339V23.6241C62.1942 24.9114 63.7021 26.3447 66.2278 27.4581C69.2562 28.7931 73.3186 29.5284 77.6671 29.5284C82.0154 29.5284 86.0778 28.7931 89.1062 27.4581C91.6319 26.3447 93.1398 24.9114 93.1398 23.6241V20.2339C92.3647 20.7815 91.4604 21.2867 90.4318 21.7402C86.9949 23.2553 82.4617 24.0896 77.667 24.0896Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6671 55.688C82.0154 55.688 86.0779 54.9528 89.1062 53.6178C91.632 52.5043 93.1399 51.0711 93.1399 49.7839V46.3936C92.3647 46.9412 91.4604 47.4464 90.4319 47.8999C86.9951 49.4149 82.4618 50.2492 77.6671 50.2492C75.7172 50.2492 73.8231 50.1124 72.01 49.845C71.9509 51.6661 71.6352 53.4232 71.0981 55.082C73.1528 55.48 75.3899 55.688 77.6671 55.688Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.218 36.5767C70.1114 37.6552 73.802 38.2482 77.667 38.2482C82.0153 38.2482 86.0777 37.513 89.1061 36.178C91.6318 35.0645 93.1397 33.6313 93.1397 32.344V28.9537C92.3646 29.5014 91.4603 30.0067 90.4317 30.46C86.9949 31.9751 82.4617 32.8094 77.667 32.8094C72.8722 32.8094 68.3389 31.9751 64.9022 30.46C63.8736 30.0066 62.9693 29.5014 62.1942 28.9537V32.5366C64.0902 33.5938 65.7881 34.9638 67.218 36.5767Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.667 46.9681C82.0153 46.9681 86.0777 46.2328 89.1061 44.8978C91.6318 43.7844 93.1397 42.3511 93.1397 41.0639V37.6736C92.3646 38.2212 91.4603 38.7264 90.4317 39.1799C86.9949 40.695 82.4617 41.5293 77.667 41.5293C75.0123 41.5293 72.4173 41.2675 70.0481 40.7766C70.9247 42.5454 71.5348 44.4683 71.8257 46.493C73.6775 46.8068 75.6357 46.9681 77.667 46.9681Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2277 18.7382C69.2561 20.0732 73.3185 20.8085 77.6669 20.8085C82.0153 20.8085 86.0777 20.0732 89.1061 18.7382C91.6318 17.6248 93.1397 16.1915 93.1397 14.9043C93.1397 13.617 91.6318 12.1837 89.1061 11.0703C86.0777 9.73522 82.0152 9 77.6669 9C73.3186 9 69.2561 9.73522 66.2277 11.0703C63.702 12.1837 62.1941 13.6169 62.1941 14.9043C62.1941 16.1916 63.702 17.6248 66.2277 18.7382Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7373 49.2187C68.7373 40.5021 61.6398 33.4105 52.9159 33.4105C44.192 33.4105 37.0945 40.5021 37.0945 49.2187C37.0945 57.9353 44.192 65.0269 52.9159 65.0269C61.6398 65.0269 68.7373 57.9353 68.7373 49.2187ZM55.3825 57.9234H54.5579V60.6189H51.2739V57.9234H46.8442V54.6422H55.3825C56.465 54.6422 57.3456 53.7623 57.3456 52.6806C57.3456 51.599 56.465 50.7191 55.3825 50.7191H51.4201C48.6042 50.7191 46.3133 48.4301 46.3133 45.6166C46.3133 42.8519 48.5255 40.5955 51.2739 40.5176V37.8184H54.5579V40.5139H58.1099V43.7951H51.4201C50.415 43.7951 49.5973 44.6122 49.5973 45.6166C49.5973 46.6208 50.415 47.4379 51.4201 47.4379H55.3825C58.2758 47.4379 60.6296 49.7898 60.6296 52.6806C60.6295 55.5715 58.2757 57.9234 55.3825 57.9234Z",
    fill: "#FFC700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.0468,
    height: 56,
    fill: "white",
    transform: "translate(37.0802 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashGold);
export default __webpack_public_path__ + "static/media/cash-gold.746c5128ffc6aa712f11dc3187823001.svg";
export { ForwardRef as ReactComponent };